<span *ngIf="status === 'Unpaid'" [attr.label]="status">待付款</span>
<span *ngIf="status === 'Paid'" [attr.label]="status">已支付</span>
<span *ngIf="status === 'Completed'" [attr.label]="status">已完成</span>
<span *ngIf="status === 'Cancelled'" [attr.label]="status">已取消</span>
<span *ngIf="status === 'Refunded'" [attr.label]="status">已退款</span>
<span *ngIf="status === 'Pending'" [attr.label]="status">待解决</span>
